import { Spinner } from '@elotech/components';
import classnames from 'classnames';
import { ReactNode } from 'react';

type BlockDashValue = {
  title: string;
  number: ReactNode;
};

type Props = {
  xs?: number;
  sm?: number;
  md?: number;
  icon: string;
  values: BlockDashValue[];
  title: ReactNode;
  onClick?(): void;
  error?: boolean;
  alignItem?: 'left' | 'center';
  className?: string;
  loading?: boolean;
  children?: ReactNode;
};

export const BlockDashMultiple = ({
  xs = 12,
  sm = 12,
  md = 12,
  icon,
  values,
  title,
  onClick,
  error,
  alignItem,
  className,
  children,
  loading = false
}: Props) => {
  const classesBlockDash = classnames('block-dash', className, {
    error,
    [`${alignItem}`]: !!alignItem,
    list: !!children
  });
  return (
    <div className={`col-md-${md} col-sm-${sm} col-xs-${xs}`}>
      <div className={classesBlockDash} onClick={onClick}>
        <i className={icon} />
        <div className="title" style={{ fontWeight: '600' }}>
          {title}
        </div>
        {loading ? (
          <Spinner />
        ) : (
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              width: '100%',
              justifyContent: 'space-around'
            }}
          >
            {values.map((value, index) => (
              <div
                key={index}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className="number">{value.number || '-'}</div>
                <div className="title">{value.title}</div>
              </div>
            ))}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
